module.exports = __webpack_public_path__ + "leo-09ca74682bdd1bd62931.png";